import { Markdown } from '../Markdown';
import { formatRelative } from '../../lib/format';
import { RailCard } from './RailCard';

/**
 * "Where we are": the running summary the PM rewrites from scratch on every
 * turn (decided / open questions / next step), so a newcomer understands the
 * whole thread in ten seconds.
 */
export function ThreadSummaryCard({
  summary,
  summaryUpdatedAt,
  collapsible = false,
}: {
  summary: string | null;
  summaryUpdatedAt: string | null;
  collapsible?: boolean;
}) {
  return (
    <RailCard title="Where we are" collapsible={collapsible} defaultOpen>
      {summary ? (
        <>
          <Markdown className="prose-sm">{summary}</Markdown>
          <p className="mt-3 text-2xs text-ink-faint">
            Updated {formatRelative(summaryUpdatedAt)} by the PM
          </p>
        </>
      ) : (
        <p className="text-sm text-ink-faint">
          The PM writes a running summary here after its first reply.
        </p>
      )}
    </RailCard>
  );
}
